<template>
  <el-date-picker
    v-model="dates"
    type="daterange"
    range-separator="-"
    start-placeholder="Start Date"
    end-placeholder="End Date"
    value-format="YYYY-MM-DD"
    format="DD/MM/YYYY"
    :disabled="disabled"
    :disabled-date="DisabledPeriod"
    @change="changePeriod"
    style="width: 100%"
    class="date"
  >
  </el-date-picker>
</template>

<script setup>
import { ref, watch } from 'vue';
import dateJs from '@/assets/js/date';

const props = defineProps({
  mediaStartDate: {
    type: Date,
  },
  mediaEndDate: {
    type: Date,
  },
  disabled: {
    type: Boolean,
  },
  modelValue: {
    type: Array,
    default: null,
  },
});

const emits = defineEmits(['update:modelValue', 'changePeriod']);

const dates = ref(props.modelValue);

// 监听绑定
watch(
  () => props.modelValue,
  (newValue) => {
    dates.value = newValue;
  }
);

// Disabled: 禁用开始日期日子
const DisabledPeriod = (val) => {
  return (
    dateJs.DateDiff(props.mediaStartDate, val) < 0 ||
    dateJs.DateDiff(val, props.mediaEndDate) < 0
  );
};

const changePeriod = () => {
  emits('update:modelValue', dates.value);

  emits('changePeriod');
};
</script>
